import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-administracion-motivo-devolucion',
  templateUrl: './administracion-motivo-devolucion.component.html',
  styleUrls: ['./administracion-motivo-devolucion.component.css']
})
export class AdministracionMotivoDevolucionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
